import classnames from "classnames";
import React from "react";
import PitchAnimationContainer from "../../containers/PitchAnimation/PitchAnimationContainer";

const style = require("./PitchAnimationScreen.scss"); // tslint:disable-line no-var-requires

export function PitchAnimationScreen() {
    return (
        <div className={classnames(style.pitchAnimation)}>
            <PitchAnimationContainer />
        </div>
    );
}
